import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from 'src/app/services/configuration/translation-service';

@Pipe({ name: 'translate', pure: false })

export class TranslationPipe implements PipeTransform {
  translationService = inject(TranslationService);

  transform(key: string, params?: Record<string, any>, className: string | null = null): string {
    return this.translationService.translate(key, params, className);
  }
}
